import { render, staticRenderFns } from "./Edicion.vue?vue&type=template&id=59d6f8dd&scoped=true&"
import script from "./Edicion.vue?vue&type=script&lang=js&"
export * from "./Edicion.vue?vue&type=script&lang=js&"
import style0 from "./Edicion.vue?vue&type=style&index=0&id=59d6f8dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d6f8dd",
  null
  
)

export default component.exports